export const CHARTIQ_DRAW_TOGGLE_DRAWING = 'chartiqdraw/TOGGLE_DRAWING';
export const CHARTIQ_DRAW_TOGGLE_DRAWING_TOOLBAR = 'chartiqdraw/TOGGLE_DRAWING_TOOLBAR';
export const CHARTIQ_DRAW_SET_FONT_FAMILY = 'chartiqdraw/SET_FONT_FAMILY';
export const CHARTIQ_DRAW_SET_FONT_SIZE = 'chartiqdraw/SET_FONT_SIZE';
export const CHARTIQ_DRAW_SET_FONT_STYLE = 'chartiqdraw/SET_FONT_STYLE';
export const CHARTIQ_DRAW_SET_FILL_STYLE = 'chartiqdraw/SET_FILL_STYLE';
export const CHARTIQ_DRAW_SET_LINE_COLOR = 'chartiqdraw/SET_LINE_COLOR';
export const CHARTIQ_DRAW_SET_FILL_COLOR = 'chartiqdraw/SET_FILL_COLOR';
export const CHARTIQ_DRAW_CHANGE_LINE_PARAMS = 'chartiqdraw/CHANGE_LINE_PARAMS';
export const CHARTIQ_DRAW_CHANGE_TOOL = 'chartiqdraw/CHANGE_TOOL';
